import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/Headers/Header.jsx';
import ButtonBase from "./components/buttons/ButtonBase.jsx";
import DownloadButton from "./components/buttons/DownloadButton.jsx";
import * as dayjs from 'dayjs';
import VideoStreaming from "./components/VideoStreaming";
import StreamRecord from './components/StreamRecord.jsx';
import { $host } from '../../http';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.jsx';

const StudentStream = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { ParagraphTitle, themeTitle, streamId, themeId, homeworkId } = location.state;
    console.log(location.state);
    const [streamConnected, setStreamConnected] = useState(false);
    const [streamStatus, setSteamStatus] = useState(null);
    const [streamInfo, setSteamInfo] = useState(null);
    const [recordLink, setRecordLink] = useState(null);
    const [loading, setLoading] = useState(true); // Добавляем состояние загрузки

    const serverUrl = 'wss://webinar.boost-ai.ru';
    const [accessToken, setAccessToken] = useState();

    const enterStreamRoom = async () => {
        let wID = streamId;
        const { data } = await $host.get(`/api/webinar/join/room/${wID}`);
        const token = await data.jwt_token;
        setAccessToken(token);
        setStreamConnected(true);
    };

    useEffect(() => {
        const checkStreamStatus = async () => {
            try {
                const { data } = await $host.get(`/api/students/webinars/${themeId}`);
                const { is_open, schedule_date, link_recording } = await data;
                setSteamInfo(await data);
                if (is_open) {
                    setSteamStatus('active');
                    await enterStreamRoom();
                    return;
                }
                const isWaiting = (!schedule_date || dayjs().isBefore(dayjs(schedule_date))) && !link_recording;
                if (!isWaiting) {
                    setRecordLink(link_recording);
                }
                setSteamStatus(isWaiting ? 'waiting' : 'finished');
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false); // Убираем спиннер после загрузки
            }
        };

        checkStreamStatus();
    }, []);

    const videoJsOptions = {
        autoplay: false,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
            src: recordLink,
            type: 'application/x-mpegURL'
        }],
    };

    const playerRef = useRef(null);

    const handlePlayerReady = (player) => {
        playerRef.current = player;
    };

    return (
        <>
            <div className="flex flex-col max-w-[1600px] mx-auto">
                <Header className="w-full px-6" />

                {/* Здесь показываем кастомный спиннер только во время загрузки */}
                {loading ? (
                    <div className="flex justify-center items-center w-full h-full absolute top-0 left-0 z-10">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <>
                        {streamStatus === 'active' && (
                            <div className="flex flex-col gap-4 grow">
                                {streamConnected && accessToken && (
                                    <VideoStreaming streamInfo={streamInfo} url={serverUrl} token={accessToken} updateToken={enterStreamRoom} />
                                )}
                            </div>
                        )}

                        {streamStatus === 'waiting' && (
                            <div className="flex flex-col gap-4 grow p-8 items-center">
                                Стрим еще не начался

                                {homeworkId && (
                                    <div className='p-6'>
                                        <ButtonBase
                                            onClick={() => {
                                                navigate(`/themes/${themeId}/homework`, { state: { homeworkId: homeworkId } });
                                            }}
                                        >
                                            Домашняя работа
                                        </ButtonBase>
                                    </div>
                                )}
                            </div>
                        )}

                        {streamStatus === 'finished' && (
                            <div className="w-full flex flex-col md:flex-row grow md:gap-4 md:px-6 mb-6">
                                {/* Левая часть — видео + заголовки + кнопки */}
                                <div className="w-full md:w-3/4 md:max-w-[1000px]">

                                <div className="flex flex-col gap-4">

                                        {/* Видео */}
                                        <div className="px-1 mt-4">
                                        {recordLink ? <StreamRecord options={videoJsOptions} onReady={handlePlayerReady} /> : 'Стрим завершился'}
                                        </div>
                                        {/* Заголовок и подзаголовок (всегда под видео, слева) */}
                                        <div className="pl-4 text-left">
                                            <h1 className="text-xl font-bold">{themeTitle}</h1>
                                            <h2 className="text-lg text-gray-500">{ParagraphTitle}</h2>
                                        </div>

                                        <div className="flex items-center px-0.5 mt-4 mb-4">
                                            <div className="flex items-center gap-x-3">
                                                {streamInfo?.manual_pdf && (
                                                    <DownloadButton fileName="конспект" fileUrl={streamInfo.manual_pdf} />
                                                )}
                                                {streamInfo?.script_pdf && (
                                                    <DownloadButton fileName="скрипт" fileUrl={streamInfo.script_pdf} />
                                                )}
                                            </div>

                                            {homeworkId && (
                                                <ButtonBase
                                                    onClick={() => {
                                                        navigate(`/themes/${themeId}/homework`, { state: { homeworkId } });
                                                    }}
                                                    className="ml-8" // 👈 вот этот отступ можно регулировать
                                                >
                                                    Домашка
                                                </ButtonBase>
                                            )}
                                        </div>




                                    </div>
                                </div>

                                {/* Правая часть — чат (пока пустая) */}
                                <div className="hidden md:block md:w-1/4 md:min-w-[260px]">
                                    {/* Здесь потом будет чат */}
                                </div>
                            </div>
                        )}


                    </>
                )}
            </div>
        </>
    );
};

export default StudentStream;
